/* CL Reference homepage — vanilla behaviours. No dependencies, no trackers. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------ *
   * Scroll reveal
   * ------------------------------------------------------------------ */
  function initReveals(root) {
    var items = (root || document).querySelectorAll('.cl-reveal:not([data-cl-revealed])');
    if (!items.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.setAttribute('data-cl-revealed', '');
        el.classList.add('cl-in');
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('cl-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    items.forEach(function (el) {
      el.setAttribute('data-cl-revealed', '');
      io.observe(el);
    });
  }

  /* ------------------------------------------------------------------ *
   * Tabs
   * ------------------------------------------------------------------ */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-cl-tabs]:not([data-cl-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-cl-ready', '');
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[data-cl-tab]'));
      var panels = Array.prototype.slice.call(wrap.querySelectorAll('[data-cl-panel]'));
      if (!tabs.length) return;

      function select(index) {
        tabs.forEach(function (tab, i) {
          var on = i === index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.setAttribute('tabindex', on ? '0' : '-1');
        });
        panels.forEach(function (panel, i) {
          if (i === index) {
            panel.removeAttribute('hidden');
            initReveals(panel);
            initCarousels(panel);
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(i); });
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
          if (e.key === 'ArrowLeft')  next = (i - 1 + tabs.length) % tabs.length;
          if (next === null) return;
          e.preventDefault();
          select(next);
          tabs[next].focus();
        });
      });

      select(0);
    });
  }

  /* ------------------------------------------------------------------ *
   * Carousel (native scroll-snap + arrows + dots)
   * ------------------------------------------------------------------ */
  function initCarousels(root) {
    (root || document).querySelectorAll('[data-cl-carousel]:not([data-cl-ready])').forEach(function (carousel) {
      carousel.setAttribute('data-cl-ready', '');
      var track = carousel.querySelector('[data-cl-track]');
      if (!track) return;

      var prev = carousel.querySelector('[data-cl-prev]');
      var next = carousel.querySelector('[data-cl-next]');
      var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-cl-dot]'));

      function step() {
        var first = track.firstElementChild;
        if (!first) return track.clientWidth;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return first.getBoundingClientRect().width + gap;
      }

      function scrollByStep(dir) {
        track.scrollBy({ left: dir * step(), behavior: reduced ? 'auto' : 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { scrollByStep(-1); });
      if (next) next.addEventListener('click', function () { scrollByStep(1); });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          track.scrollTo({ left: i * step(), behavior: reduced ? 'auto' : 'smooth' });
        });
      });

      function sync() {
        var index = Math.round(track.scrollLeft / step());
        dots.forEach(function (dot, i) {
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { sync(); ticking = false; });
      }, { passive: true });

      sync();
    });
  }

  /* ------------------------------------------------------------------ *
   * Lookbook drawer
   * ------------------------------------------------------------------ */
  var lastFocused = null;

  function closeDrawer(drawer) {
    drawer.removeAttribute('open');
    document.documentElement.style.overflow = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function initLookbook(root) {
    (root || document).querySelectorAll('[data-cl-look-trigger]:not([data-cl-ready])').forEach(function (trigger) {
      trigger.setAttribute('data-cl-ready', '');
      trigger.addEventListener('click', function () {
        var drawer = document.getElementById(trigger.getAttribute('aria-controls'));
        if (!drawer) return;
        lastFocused = trigger;
        drawer.setAttribute('open', '');
        document.documentElement.style.overflow = 'hidden';
        var closeBtn = drawer.querySelector('[data-cl-look-close]');
        if (closeBtn) closeBtn.focus();
      });
    });

    (root || document).querySelectorAll('[data-cl-look-close], [data-cl-look-scrim]').forEach(function (el) {
      if (el.hasAttribute('data-cl-ready')) return;
      el.setAttribute('data-cl-ready', '');
      el.addEventListener('click', function () {
        var drawer = el.closest('[data-cl-look-drawer]');
        if (drawer) closeDrawer(drawer);
      });
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('[data-cl-look-drawer][open]');
    if (open) closeDrawer(open);
  });

  /* ------------------------------------------------------------------ *
   * Boot
   * ------------------------------------------------------------------ */
  function boot(root) {
    initReveals(root);
    initTabs(root);
    initCarousels(root);
    initLookbook(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // Re-init sections re-rendered by the theme editor.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();